export interface MarkdownTextUi {
  value: string;
}

export const emptyMarkdownTextUi = (): MarkdownTextUi => ({
  value: '',
});
